import { Component, ViewChild } from '@angular/core';
import { IonBackButton, IonHeader } from '@ionic/angular/standalone';
import { IonRouterOutlet, IonicModule } from '@ionic/angular';
import {
	NavigationEnd,
	Router,
	RouterLink,
	RouterLinkActive,
} from '@angular/router';
import { initCollapses, initDropdowns, initFlowbite } from 'flowbite';

import { AuthenticationService } from '../../../../core/services/authentication/authentication.service';
import { CommonModule } from '@angular/common';
import { Location } from '@angular/common';
import { LogoComponent } from '../logo/logo.component';
import { MenuOption } from '@app/core/models/menu-option.model';
import { MenuOptionComponent } from '../menu-option/menu-option.component';
import { NotificationsComponent } from '@app/modules/notifications/notifications.component';
import { ProfileButtonComponent } from '../profile-button/profile-button.component';
import { ROLES as Roles } from '@app/core/utils/roles.enums';
import { SearchComponent } from '../search/search.component';
import { SearchMobileComponent } from '../search-mobile/search-mobile.component';
import { Subscription } from 'rxjs';

@Component({
	selector: 'app-navbar',
	standalone: true,
	templateUrl: './navbar.component.html',
	styleUrl: './navbar.component.scss',
	imports: [
		CommonModule,
		IonicModule,
		RouterLink,
		RouterLinkActive,
		MenuOptionComponent,
		SearchComponent,
		ProfileButtonComponent,
		SearchMobileComponent,
		LogoComponent,
		NotificationsComponent,
		IonBackButton,
		IonHeader,
	],
})
export class NavbarComponent {
	@ViewChild(IonRouterOutlet, { static: true }) routerOutlet!: IonRouterOutlet;
	canGoBack = false;
	private routerSub!: Subscription;
	private menuOptions: MenuOption[] = [];
	role: Roles = Roles.NONE;
	roles_enums = Roles;
	/**
	 * Constructor.
	 */
	constructor(
		private _authService: AuthenticationService,
		private router: Router,
		private location: Location,
	) {}
	ngOnInit(): void {
		initFlowbite();
		initCollapses();
		initDropdowns();
		this.role = this._authService.userRole;
		this._authService.changeMenuOptions$.subscribe({
			next: (menuOptions) => {
				this.menuOptions = this._authService.menuOptions;
				this.subscriptionRouter();
			},
		});
		// Escucha el evento de finalización de navegación
	}

	private subscriptionRouter() {
		const noBackButtonRoutes = this.menuOptions.map((option) => option.route);
		// Filtra las rutas que no deben mostrar el botón de retroceso
		this.routerSub = this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				// Comprueba si la ruta actual está en la lista de rutas en las que no se muestra el botón de retroceso
				this.canGoBack = !noBackButtonRoutes.includes(this.router.url);
			}
		});
	}

	ngAfterViewInit() {
		this.canGoBack = this.routerOutlet && this.routerOutlet.canGoBack();
	}

	goBack() {
		this.location.back(); // Navega a la página anterior
	}

	ngOnDestroy() {
		// Asegurarse de que la suscripción se limpia cuando el componente se destruye
		if (this.routerSub) {
			this.routerSub.unsubscribe();
		}
	}
}

